import * as React from 'react';

import * as styles from './cardSection.module.scss';

export interface CardSectionProps {
  sectionTitle?: string;
  sectionHtml?: React.ReactNode;
  children: React.ReactNode;
}

const CardSection = ({
  sectionTitle,
  sectionHtml,
  children,
}: CardSectionProps) => {
  return (
    <section className={styles.wrapper}>
      <div className={styles.content}>
        {sectionTitle && <h2 className={styles.title}>{sectionTitle}</h2>}
        {sectionHtml}
        {children}
      </div>
    </section>
  );
};

export default CardSection;
